import { SvgIcon } from '@mui/material';

export type RowAction = 'details' | 'edit' | 'status' | 'payment';

const paths: Record<RowAction, string> = {
  details: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6',
  edit: 'M4 20h4L19 9l-4-4L4 16z M13.5 6.5l4 4',
  status: 'M3 4h18v4H3z M5 8v12h14V8 M10 12h4',
  payment:
    'M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18 M15 9.5c-.4-.9-1.6-1.5-3-1.5-1.7 0-3 .9-3 2s1.3 1.7 3 2 3 .9 3 2-1.3 2-3 2c-1.4 0-2.6-.6-3-1.5 M12 6v2 M12 16v2',
};

/** Line icons drawn like the navigation icons, so the app needs no icon package. */
export function RowActionIcon({ action }: { action: RowAction }): React.JSX.Element {
  return (
    <SvgIcon sx={{ fontSize: 18 }}>
      <path
        d={paths[action]}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
